import { Flex } from '@chakra-ui/react'
import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'

type LayoutProps = {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Flex
      w='100vw'
      minH='100vh'
      direction='column'
      justifyContent='space-between'
    >
      <Header />
      {children}
      <Footer />
    </Flex>
  )
}
export default Layout
